import { Link } from "@tanstack/react-router";

import { VusionLiveLogo } from "@/components/logos/VusionLiveLogo";
import { NavLinks } from "./NavLinks";
import { UserMenu } from "./UserMenu";

export function Navbar() {
  return (
    <nav className="fixed inset-x-0 top-0 z-50 border-b border-slate-200 bg-white">
      <div className="mx-auto px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="shrink-0">
            <VusionLiveLogo />
          </Link>

          <div className="flex flex-1 items-center justify-center">
            <NavLinks />
          </div>

          <div className="flex shrink-0 items-center">
            <UserMenu />
          </div>
        </div>
      </div>
    </nav>
  );
}
